import frLocale from "moment/locale/fr";
import React, { PropTypes } from "react";
import { FormattedMessage, intlShape } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Field,
  change as changeFieldValue,
  formValueSelector,
  getFormSubmitErrors,
  getFormSyncErrors,
  reduxForm,
} from "redux-form";
import sections, {
  ACCOUNTING,
  ASSOCIATED_BROKERS,
  CONFIGURATION,
  COVERAGE_PERIODS,
  GENERAL_INFORMATION
} from "./basic-client-sections/clientSectionEnum";

import { getTenantFromURL } from "../../../common/MultiTenancy/MultiTenancyHelper";

import validationUtils from "../../../../utils/ValidationUtils";
import userHasAccess from "../../../../utils/userHasAccess";
import { CLIENTS_VALIDATION_RULES } from "../clientValidationRules";
import ClientAcomba from "./basic-client-sections/ClientAcomba";
import ClientAdditionalConfigurations from "./basic-client-sections/ClientAdditionalConfigurations";
import ClientAddress from "./basic-client-sections/ClientAddress";
import ClientInformation from "./basic-client-sections/ClientInformation";
import ClientPayment from "./basic-client-sections/ClientPayment";

import _ from "lodash";
import moment from "moment";
import {
  ADMINISTRATOR,
  AGENT,
  DIRECTOR,
  EXTERNAL_ROLES,
  FINANCE,
  FINTECH,
  HIGH_MANAGEMENT_WITH_FINANCE,
  INFORMATION_AGENT,
  INTERNAL_ROLES,
  MANAGER,
  PLAN_ADMINISTRATOR,
} from "../../../../utils/Roles";
import * as dataActions from "../../../../utils/data/dataActions";
import {
  ACCOUNTBUSINESSUNITS_V2,
  BLOCS,
  BLOCS_V2,
  CLIENT_BROKER_RELATIONSHIP,
  CLIENT_HISTORIES,
  MEMBERS,
  CLIENT_CONFIGURATION,
  CLIENT_SYNC_OPTIONS,
  GROUPS,
} from "../../../../utils/data/models";
import { SelectInput } from "../../../common/form";
import { GM, PM } from "../enums/businessAccountTypes";
import {
  ACTIVE,
  IMPLEMENTATION,
  INACTIVE,
  TERMINATED,
} from "../enums/clientStatusTypes";
import ClientSectionSelector from "./ClientSectionSelector";
import ClientAssociatedBrokers from "./basic-client-sections/ClientAssociatedBrokers";
import ClientBlock from "./basic-client-sections/ClientBlock";
import ClientMajorCost from "./basic-client-sections/ClientMajorCost";
import CoveragePeriod from "./basic-client-sections/CoveragePeriod";

import { AUTOMATIC, MANUAL } from "../enums/automaticMemberIdentifierOptions";
import billingPeriodTypes, { RECURRING, MANUAL as MANUAL_BP_TYPES } from "../enums/billingPeriodTypes";
import { NO_SYNC, TED_DESJARDINS } from "../enums/synchronizationOptions";
import { CUSTOM } from "../../../common/enums/memberIdentifierType";
import { toast } from "react-toastify";
import { toCamelCase } from "../../../common/form/DBEnumStringHelper";

const DEFAULT_SECTION_KEY = GENERAL_INFORMATION.value;

class BasicClientsFields extends React.Component {
  static generateLocalizedRules(values) {
    let rules = {};
    let localRules = {};
    const basicRules = {
      isRequiredTrimIfFieldHasValue: {
        value: {
          field: "clientBillingPeriodType",
          expectedValues: ["RECURRING"],
        },
      },
    };
    if (values.hasOwnProperty("inactivePlan")) {
      rules[`lastActiveDate`] = {
        isRequiredTrim: {
          value: true,
        },
      };
      rules[`inactivationReasonType`] = {
        isRequiredTrim: {
          value: true,
        },
      };
    }

    if (values.hasOwnProperty("coveragePeriod")) {
      Object.keys(values.coveragePeriod).forEach((key) => {
        rules[`coveragePeriod.${key}`] = basicRules;
        const minimumDate = moment().subtract(6, "months").format("YYYY-MM-DD");
        if (
          moment(values.coveragePeriod.startDate).format("YYYY-MM-DD") <
          minimumDate
        ) {
          if (key == "startDate") {
            rules[`coveragePeriod.${key}`] = {
              lowerThanValue: {
                value: {
                  value: minimumDate,
                  customMessageKey:
                    "validation.customMessages.startDateAfterClientCreation",
                },
              },
            };
          }
        }
        if (
          Date.parse(values.coveragePeriod.endDate) <
          Date.parse(values.coveragePeriod.startDate)
        ) {
          if (key == "startDate")
            rules[`coveragePeriod.${key}`] = {
              lowerThanValue: {
                value: {
                  value: moment(values.coveragePeriod.endDate),
                  customMessageKey: "validation.customMessages.startDate",
                },
              },
            };
          if (key == "endDate")
            rules[`coveragePeriod.${key}`] = {
              higherThanValue: {
                value: {
                  value: moment(values.coveragePeriod.startDate),
                  customMessageKey: "validation.customMessages.endDate",
                },
              },
            };
        }
      });
    }
    if (values.isAutomaticMemberIdentifier) {
      rules[`memberIdentifierType`] = {
        isRequiredTrim: {
          value: true,
        },
        fieldMustHaveValueIfOtherValueSelected: {
          value: {
            otherValueKey: "syncType",
            otherExpectedValue: TED_DESJARDINS.value,
            expectedFieldValue: CUSTOM,
            customMessageKey: "validation.clientFieldValidation.tedDesjardinsValidationMemberIdentifierType"
          }
        }
      };
      rules[`clientNumber`] = {
        ...{
          regex: {
            value: {
              pattern: /^[a-zA-Z0-9]*$/,
              customMessageKey: "validation.customMessages.alphanumeric",
            }
          }
        },
      };
    }
    if (
      values.memberIdentifierType &&
      values.memberIdentifierType == "CUSTOM"
    ) {
      rules[`memberIdentifierInitialLength`] = {
        regex: {
          value: {
            pattern: /^\d*$/,
            customMessageKey: "validation.customMessages.numeric",
          },
        },
        isRequiredTrim: {
          value: true,
        },
        fieldMustHaveValueIfOtherValueSelected: {
          value: {
            otherValueKey: "syncType",
            otherExpectedValue: TED_DESJARDINS.value,
            expectedFieldValue: 9,
            customMessageKey: "validation.clientFieldValidation.tedDesjardinsValidationMemberIdentifierLength"
          }
        }
      };
    }
    localRules = { ...CLIENTS_VALIDATION_RULES, ...rules };
    return localRules;
  }
  constructor(props) {
    super(props);
    this.state = {
      selectedSectionKey: DEFAULT_SECTION_KEY,
      disabled: false,
      coveragePeriodId: this.props.initialValues.coveragePeriodId,
      coveragePeriodObj: this.props.initialValues.coveragePeriod,
      interval: 0,
      memberIdentifierType: null,
      clientNumberExists: false,
      currentClientStatusType: null,
      currentClientNumber: null,
      clientBillingPeriodType: null,
      clientBillingPeriodOptions: [],
      syncTypeOptions: [],
      hasCoveragePeriodWarning: false
    };
    moment.locale(props.locale.split("-")[0], [frLocale]);
    this.setSelectedSection = this.setSelectedSection.bind(this);
    this.setClientNumberExistsState = this.setClientNumberExistsState.bind(this);
    this.onSelectMemberIdentifierType = this.onSelectMemberIdentifierType.bind(
      this
    );
    this.onAutomaticMemberIdentifier = this.onAutomaticMemberIdentifier.bind(
      this
    );
    this.getIsPermittedByClientStatus = this.getIsPermittedByClientStatus.bind(
      this
    );
    this.getCanModifyCoveragePeriodByClientStatus = this.getCanModifyCoveragePeriodByClientStatus.bind(
      this
    );

    this.clientNumberExists = this.clientNumberExists.bind(this);
    this.changeIsPublishableForManualClient = this.changeIsPublishableForManualClient.bind(this);
    this.setHasCoveragePeriodWarning = this.setHasCoveragePeriodWarning.bind(this);
    this.canEditImplementation = userHasAccess(
      HIGH_MANAGEMENT_WITH_FINANCE,
      true
    );
    this.canEditActive = userHasAccess(
      [DIRECTOR, MANAGER, ADMINISTRATOR, FINTECH],
      true
    );
    this.canEditInactive = userHasAccess(DIRECTOR);
    this.canEditTerminated = userHasAccess(FINTECH);
    this.canEditCoveragePeriodForActive = userHasAccess(DIRECTOR);
    this.canAddOrEditImplementation = userHasAccess(FINANCE);
  }

  getChildContext() {
    return {
      scene: this.props.scene,
    };
  }

  componentWillMount() {
    this.props.dataActions.clearDataList(CLIENT_BROKER_RELATIONSHIP);
    const { initialValues } = this.props;
    if (this.props.clientId) {
      this.props.dataActions.getDataCount(
        MEMBERS,
        [`client_id==${this.props.clientId}`, MEMBERS.notArchivedFilter],
        "MEMBERS"
      );
    }

    const externalRole = userHasAccess(
      [PLAN_ADMINISTRATOR, INFORMATION_AGENT],
      true
    );
    if (!this.props.blocs.length && !externalRole) {
      this.props.dataActions.getDataList(
        BLOCS_V2,
        0,
        0,
        "",
        ["name:asc"],
        [BLOCS.archiveFilter],
        {},
        {},
        "blocId,name"
      );
    }
    if (!this.props.accountType.length && !externalRole) {
      this.props.dataActions.getDataList(
        ACCOUNTBUSINESSUNITS_V2,
        0,
        0,
        "",
        ["businessUnitName:asc"],
        "",
        {},
        {},
        "accountBusinessUnitId,businessUnitName"
      );
    }
    let clientHistoriesFields = "*, accountManager(userId,firstName,lastName,emailAddress,phone,roleId),serviceRepresentative(userId,firstName,lastName,emailAddress,phone,roleId)";
    this.props.dataActions.getDataList(
      CLIENT_HISTORIES,
      0,
      0,
      "",
      ["clientId:asc"],
      "",
      {},
      {},
      clientHistoriesFields
    );
    if (initialValues.memberIdentifierType) {
      this.setState({
        memberIdentifierType: initialValues.memberIdentifierType,
      });
    }
    if (userHasAccess(EXTERNAL_ROLES) && !this.props.create && initialValues && initialValues.clientBillingPeriodType) {
      const currentBillingPeriodEnum = billingPeriodTypes.find(
        (item) => item.value === initialValues.clientBillingPeriodType
      );

      if (currentBillingPeriodEnum) {
        this.setState({
          clientBillingPeriodOptions: [currentBillingPeriodEnum],
        });
      }
    }

    userHasAccess(INTERNAL_ROLES) && this.props.dataActions.getDataItem(CLIENT_CONFIGURATION, "").then((response) => {
      const billingPeriodTypes = response.payload.data.clients.clientBillingPeriodType || [];
      const configOptions = billingPeriodTypes && billingPeriodTypes.length > 0
        ? billingPeriodTypes.map((type) => (
          { value: type, key: `billingPeriods.types.${type.toLowerCase()}` }
        )) : [MANUAL_BP_TYPES, RECURRING];

      this.setState({ clientBillingPeriodOptions: configOptions });
    })
      .catch(() => {
        this.setState({ clientBillingPeriodOptions: [] });
      });

    userHasAccess(INTERNAL_ROLES) && this.props.dataActions.getDataItem(CLIENT_SYNC_OPTIONS, "").then((res) => {
      const referentialSyncOptions = res && res.payload && res.payload.data && res.payload.data.syncTypeOptions || [];

      const allOptions = referentialSyncOptions && referentialSyncOptions.length > 0
        ? referentialSyncOptions.map((o) => (
          { value: o, key: `clients.form.additionalConfigurations.${toCamelCase(o)}` }
        )) : [];
      this.setState({ syncTypeOptions: allOptions });
    }).catch(() => {
      toast(<FormattedMessage id="error.unknown" />, {
        type: toast.TYPE.ERROR,
        autoClose: false,
      });
    });

    if (userHasAccess(DIRECTOR)) {
      this.props.dataActions
        .getDataList(GROUPS, 0, 0, "", ["name:asc"], [GROUPS.archiveFilter], {}, {}, "groupId,name")
        .catch(() => {
          toast(<FormattedMessage id="validation.customMessages.serverErrors.genericError" />, {
            type: toast.TYPE.ERROR,
            autoClose: false,
          });
        });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { create } = this.props;
    if (this.state.currentClientStatusType === null) {
      this.setState({ currentClientStatusType: nextProps.clientStatusType }); // Set state only on first time we receive props.
    }
    this.setState({ currentClientNumber: nextProps.clientNumber });

    if (nextProps.isAutomaticMemberIdentifier === true) {
      this.props.changeFieldValue(
        "client",
        "isAutomaticMemberIdentifier",
        AUTOMATIC.value
      );
    } else if (nextProps.isAutomaticMemberIdentifier === false) {
      this.props.changeFieldValue(
        "client",
        "isAutomaticMemberIdentifier",
        MANUAL.value
      );
    }
    if (create && String(getTenantFromURL().toUpperCase()) === GM.acronym) {
      this.props.changeFieldValue(
        "client",
        "isAutomaticMemberIdentifier",
        AUTOMATIC.value
      );
    }
    if (create && String(getTenantFromURL().toUpperCase()) === PM.acronym) {
      this.props.changeFieldValue(
        "client",
        "isAutomaticMemberIdentifier",
        MANUAL.value
      );
    }
    if (create && nextProps.clientBillingPeriodType === MANUAL.value) {
      this.props.changeFieldValue(
        "client",
        "syncType",
        NO_SYNC.value
      );
    }
    if (create && this.props.clientBillingPeriodType === MANUAL.value && nextProps.clientBillingPeriodType === RECURRING.value) {
      this.props.changeFieldValue("client", "syncType", null);
    }
  }

  componentDidUpdate(prevProps) {
    const { clientBillingPeriodType, add, create } = this.props;
    const isClientBillingPeriodTypeManual = clientBillingPeriodType === MANUAL.value;
    if (this.state.clientBillingPeriodType != clientBillingPeriodType && add) {
      /**
       * This logic will only be used when user is creating a new client, if we're modifying a new client.
       * When we edit a client, we only want to rely on the value in db, since clientBillingPeriodType cannot be modified
       * when modifying a client.
       */
      this.changeIsPublishableForManualClient(isClientBillingPeriodTypeManual);
      this.setState({ clientBillingPeriodType: clientBillingPeriodType });
    }

    const isCreatingTEDClient = create && this.props.clientBillingPeriodType === RECURRING.value && this.props.syncType === TED_DESJARDINS.value;
    if (isCreatingTEDClient && prevProps.syncType !== TED_DESJARDINS.value && (this.props.isAutomaticMemberIdentifier !== AUTOMATIC.value
      || this.props.memberIdentifierType !== CUSTOM || this.props.memberIdentifierInitialLength !== 9)) {
      this.props.changeFieldValue("client", "isAutomaticMemberIdentifier", AUTOMATIC.value);
      this.props.changeFieldValue("client", "memberIdentifierType", CUSTOM);
      this.setState({ memberIdentifierType: CUSTOM });
      this.props.changeFieldValue("client", "memberIdentifierInitialLength", 9);
    }
  }

  componentWillUnmount() {
    if (
      this.state.currentClientStatusType !=
      this.props.initialValues.clientStatusType
    ) {
      this.props.isClientsDataTable
        ? this.props.updateDataTable()
        : this.props.updateClientInfo();
    }
    this.props.archiveButton(false);
  }

  clientNumberExists(e) {
    const clientNumber = e.target.value;
    const data = { clientId: this.props.clientId };

    this.setState({
      currentClientNumber: clientNumber,
      clientNumberExists: false,
    });

    if (!clientNumber) {
      this.setState({
        clientNumberExists: false,
      });
      return false;
    }
    const model = {
      path: `/v1/clients/${clientNumber}`,
    };
    const result = this.props.dataActions
      .simplePost({ model, data })
      .then((data) => {
        this.setState({
          clientNumberExists: data.payload.data,
        });
      });
    return result;
  }

  setHasCoveragePeriodWarning(value) {
    this.setState({ hasCoveragePeriodWarning: value });
  }

  onAutomaticMemberIdentifier(event) {
    if (!event.target.checked) {
      /**
       * Set these values to null, because they are integers in the db. If sent to the api as an empty string, the db won't accept it as an integer value.
       */
      this.props.changeFieldValue("client", "memberIdentifierType", null);
      this.props.changeFieldValue(
        "client",
        "memberIdentifierInitialLength",
        null
      );
      this.setState({ memberIdentifierType: null });
    }
  }

  onSelectMemberIdentifierType(e) {
    return this.setState({ memberIdentifierType: e.target.value });
  }

  changeIsPublishableForManualClient(isClientBillingPeriodTypeManual) {
    this.props.changeFieldValue("client", "isPublishable", !isClientBillingPeriodTypeManual);
  }

  getCanModifyCoveragePeriodByClientStatus() {
    const { currentClientStatusType } = this.state;

    const { add } = this.props;

    if (add) {
      return this.canAddOrEditImplementation;
    }

    switch (currentClientStatusType) {
      case IMPLEMENTATION.value:
        return this.canEditImplementation;
      case ACTIVE.value:
        return this.canEditCoveragePeriodForActive;
      case INACTIVE.value:
        return this.canEditInactive && this.canEditCoveragePeriodForActive;
      case TERMINATED.value:
        return this.canEditTerminated && this.canEditCoveragePeriodForActive;
    }
  }

  getIsPermittedByClientStatus() {
    const { currentClientStatusType } = this.state;
    const { add } = this.props;

    if (add) {
      return this.canAddOrEditImplementation;
    }

    switch (currentClientStatusType) {
      case IMPLEMENTATION.value:
        return this.canEditImplementation;
      case ACTIVE.value:
        return this.canEditActive;
      case INACTIVE.value:
        return this.canEditInactive;
      case TERMINATED.value:
        return this.canEditTerminated;
    }
  }

  setClientNumberExistsState(value) {
    this.setState({
      clientNumberExists: value
    });
  }

  renderCurrentSection() {
    const {
      add,
      initialClientStatusType,
      clientBillingPeriodType,
      countryCode,
      initialValues,
      blocs: rawBlocs,
      accountType,
      changeFieldValue,
      create,
      isAutomaticMemberIdentifier,
      syncType,
      isArchived,
      hasMembers,
      businessAccountType,
      lastActiveDate,
      automaticIdentifierConfigurationTypes,
      groupOptions,
      currentGroupOption
    } = this.props;

    const {
      disabled,
      currentClientNumber,
      clientNumberExists,
      currentClientStatusType,
      clientBillingPeriodOptions: clientBillingPeriodOptions,
    } = this.state;

    const businessAccountTypeValue = getTenantFromURL().toUpperCase();
    const isClientBillingPeriodTypeRecurring =
      clientBillingPeriodType === RECURRING.value;
    const isClientBillingPeriodTypeManual =
      clientBillingPeriodType === MANUAL.value;
    const isBusinessUnitPM = String(businessAccountTypeValue) === PM.acronym;
    const isClientNumberLengthValid = currentClientNumber;

    const blocs = this.formatBlocs(rawBlocs);
    let isPermitted = userHasAccess(
      [MANAGER, FINTECH, DIRECTOR, ADMINISTRATOR],
      true
    );

    isPermitted = this.getIsPermittedByClientStatus();
    const canModifyCoveragePeriod = this.getCanModifyCoveragePeriodByClientStatus();

    const isFinanceUser = userHasAccess([FINANCE], true);
    const canEditFinance =
      (isFinanceUser && currentClientStatusType != INACTIVE.value) ||
      userHasAccess([ADMINISTRATOR, FINTECH], true);
    const isTerminated =
      initialClientStatusType == TERMINATED.value && !userHasAccess(AGENT);

    const isDisabledField =
      disabled ||
      !isPermitted ||
      isTerminated ||
      (isArchived && !userHasAccess(MANAGER));
    const isMemberIdentifierConfigurationDuplicated =
      isClientNumberLengthValid &&
      clientNumberExists;
    const isInactivationPlanned = lastActiveDate ? true : false;
    const isNotManualPMImplementing =
      currentClientStatusType != IMPLEMENTATION.value &&
      currentClientStatusType != null &&
      String(businessAccountTypeValue) === PM.acronym &&
      isClientBillingPeriodTypeManual;

    const unauthorizedToEditPhoneNumber = (
      userHasAccess([PLAN_ADMINISTRATOR], true) ||
      (userHasAccess([MANAGER], true) && (([IMPLEMENTATION.value, INACTIVE.value].includes(this.state.currentClientStatusType)))) ||
      (userHasAccess([FINANCE], true) && !(this.state.currentClientStatusType == IMPLEMENTATION.value)) ||
      (!userHasAccess(FINTECH) && this.state.currentClientStatusType === TERMINATED.value)
    );

    const isCountryCodeDisabled = !this.props.add && isClientBillingPeriodTypeRecurring;

    switch (sections[this.state.selectedSectionKey]) {
      case GENERAL_INFORMATION:
        return (
          <div className="ClientFormSection">
            <div className="ClientSubsectionColumn">
              <ClientInformation
                add={add}
                clientBillingPeriodType={clientBillingPeriodType}
                businessAccountType={String(businessAccountTypeValue)}
                currentSyncType={this.props.currentSyncType}
                formSyncType={syncType}
                isInactive={isTerminated}
                disabled={isDisabledField}
                clientNumberExists={this.clientNumberExists}
                isMemberIdentifierConfigurationDuplicated={
                  isMemberIdentifierConfigurationDuplicated
                }
                clientStatusType={this.state.currentClientStatusType}
                hasMembers={hasMembers}
                clientBillingPeriodOptions={clientBillingPeriodOptions}
              />
            </div>
            <div className="ClientSubsectionColumn">
              <ClientAddress
                countryCode={countryCode}
                unauthorizedToEditPhoneNumber={unauthorizedToEditPhoneNumber}
                disabled={
                  disabled ||
                  isTerminated ||
                  !isPermitted ||
                  isNotManualPMImplementing
                }
                changeFieldValue={this.props.changeFieldValue}
                isClientBillingPeriodTypeManual={
                  isClientBillingPeriodTypeManual &&
                  clientBillingPeriodType !== null
                }
                isBusinessUnitPM={isBusinessUnitPM}
                isCountryCodeDisabled={isCountryCodeDisabled}
              />
            </div>
          </div>
        );
      case ACCOUNTING:
        return (
          <div className="ClientFormSection">
            <div className="ClientSubsectionColumn">
              <ClientMajorCost disabled={isDisabledField} />
              <ClientAcomba name={this.state.name} disabled={!canEditFinance} />
            </div>
            <div className="ClientSubsectionColumn">
              <ClientBlock
                blocs={blocs}
                accountType={accountType}
                disabled={isDisabledField}
                create={create}
              />
              <ClientPayment disabled={!canEditFinance} />
            </div>
          </div>
        );
      case CONFIGURATION:
        return (
          <ClientAdditionalConfigurations
            blocs={blocs}
            disabled={isDisabledField}
            businessAccountType={String(businessAccountType)}
            syncType={syncType}
            changeFieldValue={changeFieldValue}
            syncTypeOptions={this.state.syncTypeOptions}
            automaticMemberIdentifierOption={isAutomaticMemberIdentifier}
            memberIdentifierType={this.state.memberIdentifierType}
            onAutomaticMemberIdentifier={this.onAutomaticMemberIdentifier}
            onSelectMemberIdentifierType={this.onSelectMemberIdentifierType}
            create={create}
            clientNumberExists={clientNumberExists}
            clientBillingPeriodType={clientBillingPeriodType}
            currentClientStatusType={this.state.currentClientStatusType}
            currentClientNumber={this.state.currentClientNumber}
            automaticIdentifierConfigurationTypes={automaticIdentifierConfigurationTypes}
            setClientNumberExistsState={this.setClientNumberExistsState}
            groupOptions={groupOptions}
            currentGroupOption={currentGroupOption}
            isArchived={isArchived}
          />
        );
      case ASSOCIATED_BROKERS:
        return (
          <ClientAssociatedBrokers
            clientId={initialValues.clientId}
            disabled={isDisabledField}
            coveragePeriodId={this.state.coveragePeriodId}
            changeFieldValue={changeFieldValue}
            add={add}
          />
        );
      case COVERAGE_PERIODS:
        return (
          <CoveragePeriod
            initialValues={initialValues}
            create={create}
            disabled={!canModifyCoveragePeriod || isDisabledField}
            clientBillingPeriodType={clientBillingPeriodType}
            changeFieldValue={changeFieldValue}
            clientStatusType={this.props.clientStatusType}
            isInactivationPlanned={isInactivationPlanned}
            hasCoveragePeriodWarning={this.state.hasCoveragePeriodWarning}
            setHasCoveragePeriodWarning={this.setHasCoveragePeriodWarning}
          />
        );
    }
  }

  setSelectedSection(selectedSectionKey) {
    this.setState({ selectedSectionKey });
  }

  formatBlocs(rawBlocs) {
    return rawBlocs.map((b) => ({ value: b.blocId, text: b.name }));
  }

  changeValues(event, initialValues, clientHistory) {
    if (initialValues.coveragePeriodId != event.target.value) {
      this.props.dataActions.clearDataList(CLIENT_BROKER_RELATIONSHIP);
    }
    const changeFieldValue = this.props.changeFieldValue;
    const archiveButtonEdit = this.props.archiveButton;

    this.setState({
      disabled: initialValues.coveragePeriodId != event.target.value,
      coveragePeriodId: parseInt(event.target.value),
      interval: this.state.interval + 1,
    });

    Object.keys(clientHistory).forEach((key) => {
      if (clientHistory[key]) {
        if (event.target.value != initialValues.coveragePeriodId) {
          archiveButtonEdit(true);
          const initialHistory = initialValues.clientHistory[key];
          Object.keys(initialHistory).forEach((k) => {
            changeFieldValue("client", k, initialHistory[k]);
          });
          changeFieldValue(
            "client",
            "coveragePeriod.startDate",
            initialHistory.relationships.coveragePeriod.startDate
          );
          changeFieldValue(
            "client",
            "coveragePeriod.endDate",
            initialHistory.relationships.coveragePeriod.endDate
          );
        } else {
          archiveButtonEdit(false);
          Object.keys(initialValues).forEach((k) => {
            changeFieldValue("client", k, initialValues[k]);
          });
          changeFieldValue(
            "client",
            "coveragePeriod.startDate",
            initialValues.coveragePeriod.startDate
          );
          changeFieldValue(
            "client",
            "coveragePeriod.endDate",
            initialValues.coveragePeriod.endDate
          );
        }
      }
    });
  }

  render() {
    const {
      add,
      clientBillingPeriodType,
      disabled,
      blocs: rawBlocs,
      handleSubmit,
      invalid,
      clientSyncErrors,
      submitErrorsBySection,
      touch,
      coveragePeriods,
      initialValues,
    } = this.props;

    const canModifyCoveragePeriod = this.getCanModifyCoveragePeriodByClientStatus();

    const blocs = this.formatBlocs(rawBlocs);
    const visibleSections = Object.fromEntries(
      Object.entries(sections).filter(([, section]) =>
        userHasAccess(section.requiredRole)
      )
    );
    let coverages;
    if (initialValues) {
      coverages = coveragePeriods
        .filter((item) => item.client == initialValues.clientId)
        .map((item) => {
          const start = moment(item.startDate).format("MMMM Do YYYY");
          const end = moment(item.endDate).format("MMMM Do YYYY");
          const value = item.value;
          const text = `${start} - ${end}`;
          return { value, text };
        });
    } else {
      coverages = null;
    }
    let revealErrors = () => { };
    let coveragePeriodFiltered = [];
    let brokersFiltered = [];
    if (clientSyncErrors) {
      coveragePeriodFiltered = Object.keys(clientSyncErrors);
      if (clientSyncErrors.hasOwnProperty("coveragePeriod")) {
        coveragePeriodFiltered = _.without(
          coveragePeriodFiltered,
          "coveragePeriod"
        );
        if (clientSyncErrors["coveragePeriod"].hasOwnProperty("startDate")) {
          coveragePeriodFiltered.push("coveragePeriod.startDate");
        }
        if (clientSyncErrors["coveragePeriod"].hasOwnProperty("endDate")) {
          coveragePeriodFiltered.push("coveragePeriod.endDate");
        }
      }
      brokersFiltered =
        clientSyncErrors.hasOwnProperty("broker") &&
        brokersFiltered.concat(clientSyncErrors["broker"]);
    }
    if (coveragePeriodFiltered.length != 0) {
      revealErrors = () => touch(...coveragePeriodFiltered);
    }
    if (brokersFiltered && brokersFiltered.length != 0) {
      const brokersIndexedArray = brokersFiltered.flatMap((obj, index) =>
        Object.keys(obj).map((o) => `broker[${index}].${o}`)
      );
      revealErrors = () => touch(...brokersIndexedArray);
    }
    return (
      <div>
        <div className="CoveragePeriod">
          <div className="DropDownList">
            <Field
              id="coveragePeriodId"
              name="coveragePeriodId"
              props={{
                onChange: (event) => {
                  const clientHistory = initialValues.clientHistory;
                  this.changeValues(event, initialValues, clientHistory);
                },
              }}
              disabled={!canModifyCoveragePeriod}
              component={SelectInput}
              options={coverages}
              label={
                <FormattedMessage id="clients.form.sections.coveragePeriods" />
              }
            />
          </div>
        </div>
        <div className="MultiSectionsModalBody">
          <div className="SideBar">
            <ClientSectionSelector
              setSectionKey={this.setSelectedSection}
              currentSectionKey={this.state.selectedSectionKey}
              disableNavigation={invalid}
              revealErrors={revealErrors}
              submitErrorsBySection={submitErrorsBySection}
              clientSyncErrors={clientSyncErrors}
              sections={visibleSections}
            />
          </div>

          <div className="ClientForm">
            <form onSubmit={handleSubmit}>
              {this.renderCurrentSection({
                disabled,
                blocs,
                add,
                clientBillingPeriodType,
              })}
            </form>
          </div>
        </div>
      </div>
    );
  }
}

BasicClientsFields.propTypes = {
  add: PropTypes.bool,
  changeFieldValue: PropTypes.func,
  clientBillingPeriodType: PropTypes.string,
  countryCode: PropTypes.string,
  disabled: PropTypes.bool,
  historyData: PropTypes.bool,
  blocs: PropTypes.array,
  clients: PropTypes.array,
  initialValues: PropTypes.object,
  scene: PropTypes.string,
  validation: PropTypes.object,
  handleSubmit: PropTypes.func,
  invalid: PropTypes.bool,
  submit: PropTypes.func,
  clientSyncErrors: PropTypes.object,
  submitErrorsBySection: PropTypes.object,
  touch: PropTypes.func,
  clientStatusType: PropTypes.string,
  initialClientStatusType: PropTypes.string,
  isAutomaticMemberIdentifier: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
  ]),
  syncType: PropTypes.string,
  businessAccountType: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  dataActions: PropTypes.object,
  coverageAction: PropTypes.object,
  create: PropTypes.bool,
  archiveButton: PropTypes.func,
  updateDataTable: PropTypes.func,
  updateClientInfo: PropTypes.func,
  clientId: PropTypes.number,
  clientName: PropTypes.string,
  locale: PropTypes.string,
  clientNumber: PropTypes.string,
  accountType: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  coveragePeriods: PropTypes.array,
  hasMembers: PropTypes.bool,
  isClientsDataTable: PropTypes.bool,
  isArchived: PropTypes.bool,
  lastActiveDate: PropTypes.string,
  automaticIdentifierConfigurationTypes: PropTypes.array,
  clientBillingPeriodOptions: PropTypes.array,
  memberIdentifierType: PropTypes.string,
  memberIdentifierInitialLength: PropTypes.number,
  currentSyncType: PropTypes.string,
};

BasicClientsFields.defaultProps = {
  add: false,
  disabled: false,
  isClientsDataTable: false,
  scene: "",
};

BasicClientsFields.contextTypes = {
  getData: PropTypes.func,
  intl: intlShape,
};

BasicClientsFields.childContextTypes = {
  scene: PropTypes.string,
};

const selector = formValueSelector("client");

const buildSubmitErrorsBySection = (sections, submitErrors) => {
  // note: the submit errors are defined based on the server response,
  // in ClientsDataTable.updateClient / ClientsDataTable.createClient
  let sectionMap = {};
  Object.values(sections).forEach((section) => {
    sectionMap[section.value] = {};
  });
  for (const field in submitErrors) {
    let errorSectionKey;
    switch (field) {
      case "designator":
      case "name":
        errorSectionKey = GENERAL_INFORMATION.value;
        break;
      case "businessAccountType":
        errorSectionKey = ACCOUNTING.value;
        break;
      case "coveragePeriod":
        errorSectionKey = COVERAGE_PERIODS.value;
        break;
      case "clientNumber":
        errorSectionKey = GENERAL_INFORMATION.value;
        break;
      case "blocId":
        errorSectionKey = ACCOUNTING.value;
        break;
      default:
        errorSectionKey = undefined;
        break;
    }
    sectionMap[errorSectionKey].errors = {
      ...sectionMap[errorSectionKey].errors,
      [field]: submitErrors[field],
    };
  }
  return sectionMap;
};

function mapStateToProps(state) {
  const syncErrors = getFormSyncErrors("client")(state);
  const submitErrors = getFormSubmitErrors("client")(state);
  const submitErrorsBySection = buildSubmitErrorsBySection(
    sections,
    submitErrors
  );
  const accounts =
    state.data.accountBusinessUnits && state.data.accountBusinessUnits.items
      ? state.data.accountBusinessUnits.items
      : [];
  const clientHistory = state.data.clientHistories || [];
  const members = state.data.membersCount;
  let hasMembers = null;
  if (members && members.hasOwnProperty("count")) {
    hasMembers = members.count > 0;
  }
  const clients = state.data.clients || {};
  const initialClientStatusType = clients.active
    ? clients.active.clientStatusType
    : IMPLEMENTATION.value;
  const lastActiveDate = clients.active ? clients.active.lastActiveDate : null;
  const activeClients = clients.active;
  const periods = [activeClients] || [];

  let name = name;
  let accountType = [];
  let coveragePeriods = [];
  Object.entries(periods).map((o) => {
    if (o[1] != null)
      o[1].hasOwnProperty("coveragePeriod")
        ? coveragePeriods.push({
          value: o[1].coveragePeriodId,
          client: o[1].clientId,
          startDate: o[1].coveragePeriod.startDate,
          endDate: o[1].coveragePeriod.endDate,
        })
        : null;
  });

  Object.keys(clientHistory).map((key) => {
    if (clientHistory[key])
      clientHistory[key].hasOwnProperty("coveragePeriod")
        ? coveragePeriods.push({
          value: clientHistory[key].coveragePeriodId,
          client: clientHistory[key].clientId,
          text: clientHistory[key].coveragePeriod.name,
          startDate: clientHistory[key].coveragePeriod.startDate,
          endDate: clientHistory[key].coveragePeriod.endDate,
        })
        : null;
  });
  Object.entries(accounts).map((o) => {
    if (o[1] != null)
      o[1].hasOwnProperty("accountBusinessUnitId")
        ? accountType.push({
          value: o[1].accountBusinessUnitId,
          text: o[1].businessUnitName,
        })
        : null;
  });

  const rawGroups = state.data.groups && state.data.groups.items ? state.data.groups.items : [];
  const groupOptions = rawGroups.map((g) => ({ value: `${g.groupId}`, text: g.name }));

  const activeClientGroup = state.data.clients && state.data.clients.active && state.data.clients.active.group;
  const currentGroupOption = activeClientGroup
    ? [{ value: `${activeClientGroup.groupId}`, text: activeClientGroup.name }]
    : [];

  return {
    countryCode: selector(state, "countryCode"),
    clientStatusType: selector(state, "clientStatusType"),
    clientBillingPeriodType: selector(state, "clientBillingPeriodType"),
    businessAccountType: selector(state, "businessAccountType"),
    isAutomaticMemberIdentifier: selector(state, "isAutomaticMemberIdentifier"),
    syncType: selector(state, "syncType"),
    clientNumber: selector(state, "clientNumber"),
    isArchived: selector(state, "isArchived"),
    currentSyncType: state.data.clients && state.data.clients.active && state.data.clients.active.syncType,
    submitErrorsBySection,
    clientSyncErrors: syncErrors,
    accountType,
    coveragePeriods,
    locale: state.auth.user.languageCode,
    initialClientStatusType: initialClientStatusType,
    hasMembers,
    lastActiveDate: lastActiveDate,
    groupOptions,
    currentGroupOption,
    groupId: selector(state, "groupId"),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  withRef: true,
})(
  reduxForm({
    form: "client",
    validate: (values) =>
      validationUtils.validate(
        values,
        BasicClientsFields.generateLocalizedRules(values)
      ),
  })(BasicClientsFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client-form/BasicClientFields.js